import script from "./sf-markdown-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-markdown-editor.vue?vue&type=script&setup=true&lang=ts"

import "./sf-markdown-editor.vue?vue&type=style&index=0&id=6ffb0cf4&lang=scss"

const __exports__ = script;

export default __exports__